import React from "react";
import { v4 as uuidv4 } from "uuid";

import Landing from "./Landing";

import actionHeaderActions from "../../flux/actions/ActionHeaderActions";
import rolesActions from "../../flux/actions/RolesAndPermissionsActions";

import { ISidebarDetail, SidebarDetail } from "../../models/shared/SidebarDetail";
import * as CONSTANTS from "../../utilities/Constants";

import IActionHeaderFormData from "../../models/shared/ActionHeaderData";
import { Translation } from "react-i18next";
import NoDataOnboarding from "../shared/NoDataOnboarding";
import loadingActions from "../../flux/actions/LoadingActions";
import userActions from "../../flux/actions/UserActions";

import roleListStore from "../../flux/stores/rolesandpermissions/ListStore";
import roleByIdStore from "../../flux/stores/rolesandpermissions/ByIdStore";
import roleEditStore from "../../flux/stores/rolesandpermissions/EditStore";
import userByIdStore from "../../flux/stores/user/ByIdStore";
import { RoleFormData } from "../../models/rolesAndPermission/RoleFormData";

import Sidebar from "../sharedNew/sidebarCommon/sidebar";
import SidebarCollapse from "../sharedNew/sidebar/SidebarCollapse";
import SidebarList from "../sharedNew/sidebarCommon/sidebarList";
import History from "../../utilities/History";

import { IRoleViewData, defaultRoleData } from "../../models/rolesAndPermission/RoleViewData";
import { IScopeRoleData } from "../../models/rolesAndPermission/ScopeRoleData";
import auth from "../../utilities/Auth";

import triggerNotifications from "../../utilities/TriggerNotifications";
import i18next from "i18next";
import getLicenseDetailsStore from "../../flux/stores/license/GetLicenseDetailsStore";
import licenseActions from "../../flux/actions/LicenseActions";
import { Spinner } from "@abb/abb-common-ux-react";


interface IRoleAndPermissionsLandingState {
  activeId: string;
  searchValue: string;
  listData: ISidebarDetail[];
  collapseSidebar: boolean;
  isFullSidebarVisible: boolean;
  activeScopeData: any;
  roleListData: any;
  activeRoleData: IRoleViewData[];
  reducedArray: any;
  isEdit: boolean;
  licenseDetails: any;
  isLicenseApplicable: boolean;
  isLoading: boolean;
}

export default class Index extends React.Component<{ location: any }, IRoleAndPermissionsLandingState> {
  private _mount = false;
  private _reloadFirst = true;
  private _id = "";
  private _page: number = 1;
  private _hasMore: boolean = false;
  private scopeData:any = [];
  private payloadData:any = [];
  private filteredArray:any = [];
  private activeUser:any = {}
  private userRole: string = "";

  constructor(props: { location: any }) {
    super(props);

    this._mount = false;

    this.state = {
      collapseSidebar: false,
      activeId: "",
      searchValue: "",
      listData: [],
      isFullSidebarVisible: true,
      activeScopeData: [],
      roleListData: defaultRoleData,
      activeRoleData: [],
      reducedArray: {},
      isEdit: true,
      licenseDetails: [],
      isLicenseApplicable: false,
      isLoading: false
    };
  }

  componentDidMount() {
    this._mount = true;
    const addRequest = {
      moduleName: CONSTANTS.MODULE_ROLES_AND_PERMISSIONS,
      createData: new RoleFormData(false, uuidv4(), CONSTANTS.DefaultGuid, false, "", ""),
    } as IActionHeaderFormData;
    actionHeaderActions.common(addRequest).then();
    
    getLicenseDetailsStore.on(CONSTANTS.CHANGE_EVENT, (state) => {
      this.setState({ licenseDetails: state.licenseData.data });
    });
    this.getLicenseData();
    
    if (this.props.location.state && this.props.location.state.isReloadFirst !== undefined) {
      this._reloadFirst = this.props.location.state.isReloadFirst;
      this._id = this.props.location.state.id;
    }
    
    roleListStore.on('change', (state) => {
      this.setState({roleListData: state.roleDataList})
      const data = state.roleDataList as IRoleViewData[];
      const items: ISidebarDetail[] = [];
      data.forEach(element => {
        items.push(new SidebarDetail(element._id, element.displayName));
      });

      this.setState({ listData: items },
        () => {
          if (this._reloadFirst) {
            this.triggerGetById(items[0].id)
          } else {
            this.triggerGetById(this._id)
          }
        }
      );
    });

    roleByIdStore.on('change', (state) => {
      this.setState({
        activeScopeData: state.roleData,
      });
      this.scopeData = JSON.parse(JSON.stringify(state.roleData));
    })

    roleEditStore.on('change', (state) => {
      const data = state.data
    })

    let userID = auth.getUserId();
    userByIdStore.on('change', (state) => {
      this.activeUser = state.userData
    });

    userActions.getById(userID).then(() => {
      this.userRole = this.activeUser?.role?.name
    })

  }

  private getLicenseData = () => {
    this.setState({isLoading: true});
    licenseActions
      .getLicenseDetails()
      .then(() => {
        rolesActions.getAll().then(() => {
          this.setState({isLoading: false});
        }).catch((error) => {
          console.error(error);
          this.setState({isLoading: false});
        });
        const response: any = this.state.licenseDetails?.some((node:any) => !node.isLicenseApplicable);
        if (response) {
          this.setState({ isLicenseApplicable: false });
        } else {
          this.setState({ isLicenseApplicable: true });
        }
      })
  }

  private triggerGetById(id: string) {
    rolesActions.getById(id).then(() => {
      const activeRole = this.state.roleListData.filter((x:any) => x._id === id)
      this.setState({ activeId: id, activeRoleData: activeRole});
      let reducedArray;
      if(this.state.activeScopeData.length !== 0){
        let activeScopeData:any = [];
        if(!this.state.isLicenseApplicable){
          activeScopeData = this.state.activeScopeData.filter((x:any) => x.group !== "LicenseManagement")
        } else{
          activeScopeData = this.state.activeScopeData
        }
        reducedArray = activeScopeData.reduce((x: any, y: any) => {
          const { group } = y;
          x[group] = x[group] ?? [];
          x[group].push(y)
          return x;
        }, {})
      }
      this.setState({reducedArray: reducedArray})
      this.setState({isEdit: true})
    });
  }

  public onSelectLink = (id: string) => {
    this.setState({ activeId: id });
    this.triggerGetById(id);
  }

  public onCreateClick = () => {
    const createData = new RoleFormData(false, uuidv4(), CONSTANTS.DefaultGuid, false, "", ""); 
    History.push(CONSTANTS.ROLESANDPERMISSIONS_CREATE_URL, createData);
  }

  public onCollapseSidebar = () => {
    this.setState({
      collapseSidebar: !this.state.collapseSidebar
    })
  }

  public fetchMore = () => {
    loadingActions.setLoading(true);
    this._page = this._page + 1;
  }


  public viewAll() {
    History.push(CONSTANTS.USER_VIEW_ALL);
  }

  public onsearch = (value: any) => {
    this.setState({searchValue: value},
      () => this.applyNameFilter());
  }

  public applyNameFilter = () => {
    this.filteredArray = this.state.roleListData.filter((x:any) => {
      const a = this.state.searchValue.toLowerCase();
      const b = x.displayName.toLowerCase();
      return !a || b.includes(a)
    })
    const items: ISidebarDetail[] = [];
    this.filteredArray?.forEach((element:any) => {
      items.push(new SidebarDetail(element._id, element.displayName));
    });
    this.setState({ listData: items },
      () => {
        if(items.length !== 0){
          if (this._reloadFirst) {
            this.triggerGetById(items[0]?.id)
          } else {
            this.triggerGetById(this._id)
          }
        }
      }
    );
  }

  public checkboxClickHandler = (item: any, data: any) => {
    this.payloadData = [];
    if(item === data.name){
      this.scopeData = this.scopeData.map((x:any) => {
        x.group === item ? x.active = !data.active : x.active
        return x;
      })
      this.payloadData = this.scopeData.filter((x:any) => x.active === true)
      const duplicateArray: any = this.state.reducedArray
      const ActiveNode = duplicateArray[item].map((x:any) => {
        x.name === x.group ? x.active = !data.active : x.active = data.active
        return x;
      })
      duplicateArray[item] = ActiveNode;
      this.setState({reducedArray: duplicateArray})
    } else{
      this.scopeData.find((x:any) => x.id === data.id).active = !data.active
      this.payloadData = this.scopeData.filter((x:any) => x.active === true)
      const duplicateArray: any = this.state.reducedArray
      const ActiveNode = duplicateArray[item].find((x:any) => x.id === data.id)
      const ActiveNodeIndex = duplicateArray[item].findIndex((x:any) => x.id === data.id)
      ActiveNode.active = !data.active;
      duplicateArray[item][ActiveNodeIndex] = ActiveNode;
      this.setState({reducedArray: duplicateArray})
    }
  }

  public onSaveClick = () => {
    if(this.payloadData.length !== 0){
      rolesActions.put(this.payloadData, this.state.activeRoleData[0]).then(() => {
        this.setState({isEdit: true})
        triggerNotifications.success([i18next.t(CONSTANTS.ROLE_UPDATED)])
        this.payloadData = [];
      }).catch((error:any) => {
        triggerNotifications.errors(error).then()
      });
    } else{
      this.setState({isEdit: true})
      triggerNotifications.info(CONSTANTS.NO_ROLES_EDITED);
    }
  }

  public onEditClick = () => {
    this.setState({isEdit: false})
  }

  public onCancelClick = () => {
    this.setState({isEdit: true})
    this.triggerGetById(this.state.activeId)
  }

  public render() {
    return (
      <Translation>
        {
          t =>
            <div className="layout-margin">
              {this.state.isLoading ? (<div style={{ display: "flex", alignItems: "center", justifyContent: "center", textAlign: 'center', height: "90vh" }}><Spinner color="grey" sizeClass="medium" /></div>) : 
              (<>{(this.state.listData.length === 0 && this.state.searchValue.length === 0) ?
                <NoDataOnboarding moduleName={CONSTANTS.MODULE_ROLES_AND_PERMISSIONS} onCreateClick={this.onCreateClick} /> :
                <React.Fragment>
                {
                  !this.state.collapseSidebar ?
                    <div>
                      <Sidebar
                        onCollapseSidebar={this.onCollapseSidebar}
                        searchValue={this.state.searchValue}
                        onSearch={this.onsearch}
                        showCloneIcon={false}
                      >
                        <SidebarList
                          onSelectLink={this.onSelectLink}
                          listData={this.state.listData}
                          activeId={this.state.activeId}
                          fetchMore={this.fetchMore}
                          hasMore={this._hasMore}
                          module={CONSTANTS.MODULE_ROLES_AND_PERMISSIONS}
                        >
                        </SidebarList>
                      </Sidebar>
                    </div>
                    :
                    <SidebarCollapse 
                    onCollapseSidebar={this.onCollapseSidebar} 
                    onCreateClick={this.onCreateClick}
                    viewAll={this.viewAll}
                    showCloneIcon={false}
                    ></SidebarCollapse>
                }
                <div className={!this.state.collapseSidebar ? "main-layout ml-3 no-padding" : "main-full-layout float-right"}>
                  {this.state.activeRoleData && <Landing 
                  activeRoleScope={this.state.activeScopeData} 
                  activeRoleData={this.state.activeRoleData[0]}
                  reducedArray={this.state.reducedArray}
                  checkboxClickHandler={this.checkboxClickHandler}
                  onSaveClick={this.onSaveClick}
                  onEditClick={this.onEditClick}
                  onCancelClick={this.onCancelClick}
                  isEdit={this.state.isEdit}
                  authKey={CONSTANTS.AUTHKEY_ROLES}
                  activeUserRole={this.userRole}
                   />}
                </div>
              </React.Fragment>
                }</>)}
            </div>
        }
      </Translation>
    );

  }
}
